import { render, staticRenderFns } from "./MainRightBlock.vue?vue&type=template&id=055afcfc&"
import script from "./MainRightBlock.vue?vue&type=script&lang=js&"
export * from "./MainRightBlock.vue?vue&type=script&lang=js&"
import style0 from "./MainRightBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports